import React from 'react';
const TermsConditions = () => {
  return <div className="bg-gray-50 min-h-screen" data-id="element-492">
      <div className="bg-[#1a3a6c] text-white py-16" data-id="element-493">
        <div className="container mx-auto px-4 text-center" data-id="element-494">
          <h1 className="text-4xl font-bold mb-6" data-id="element-495">Terms & Conditions</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-496">
            The terms and conditions that govern your use of our services.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-497">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-498">
          <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-499">
            Terms and Conditions
          </h2>
          <section className="mb-8" data-id="element-500">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-501">Overview</h3>
            <p className="text-gray-700" data-id="element-502">
              This website (opticore.it.com) is operated by Opticore. Throughout
              this site, the terms "we," "us," and "our" refer to Opticore.
              Opticore provides this website, including all content, tools, and
              services, subject to your acceptance of these terms, conditions,
              policies, and notices. These Terms govern your use of the Opticore
              website and your purchase of service plans.
            </p>
          </section>
          <section className="mb-8" data-id="element-503">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-504">
              Company Information
            </h3>
            <ul className="list-disc pl-6 text-gray-700" data-id="element-505">
              <li data-id="element-506">Opticore</li>
              <li data-id="element-507">113 Church Rd, Birmingham B25 8UX</li>
              <li data-id="element-508">Email: 23tata0716@gmail.com</li>
              <li data-id="element-509">Phone: 0800 055 4969</li>
            </ul>
          </section>
          <section className="mb-8" data-id="element-510">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-511">
              Service Overview
            </h3>
            <p className="text-gray-700" data-id="element-512">
              Opticore offers appliance repair and maintenance cover plans. Each
              plan entitles customers to unlimited repairs on covered appliances
              (such as your washing machine, boiler, or drainage system) during
              the subscription period. Full details of each plan, including
              pricing, duration, and inclusions, are clearly available on our
              product and checkout pages.
            </p>
          </section>
          <section className="mb-8" data-id="element-513">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-514">
              Pricing and Currency
            </h3>
            <p className="text-gray-700" data-id="element-515">
              All prices are in GBP (£ - British Pounds Sterling) and all
              charges are processed in GBP. Payments are securely accepted via
              Visa, Mastercard, and other major debit and credit cards.
            </p>
          </section>
          <section className="mb-8" data-id="element-516">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-517">
              Order Confirmation
            </h3>
            <p className="text-gray-700" data-id="element-518">
              After completing your purchase, you'll receive an email
              confirmation. If you don't receive this within one hour, please
              contact 23tata0716@gmail.com.
            </p>
          </section>
          <section className="mb-8" data-id="element-519">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-520">
              Dispute Resolution
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-521">
              If you have concerns about your service plan or charges, please
              contact us directly:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4" data-id="element-522">
              <li data-id="element-523">Email: 23tata0716@gmail.com</li>
              <li data-id="element-524">Phone: 0800 055 4969</li>
            </ul>
            <p className="text-gray-700" data-id="element-525">
              We aim to resolve disputes promptly and fairly, with a focus on
              excellent customer service.
            </p>
          </section>
          <section className="mb-8" data-id="element-526">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-527">
              Modifications
            </h3>
            <p className="text-gray-700" data-id="element-528">
              We may revise these Terms from time to time. Continued use of our
              site or services after changes means you accept the updated Terms.
            </p>
          </section>
          <section className="mb-8" data-id="element-529">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-530">
              Service Plans
            </h3>
            <p className="text-gray-700" data-id="element-531">
              Our plans cover repair and maintenance for selected appliances
              (e.g., washing machines, boilers, drainage systems). Detailed plan
              information is available on each product page.
            </p>
          </section>
          <section className="mb-8" data-id="element-532">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-533">Payments</h3>
            <p className="text-gray-700" data-id="element-534">
              We accept secure card payments and Direct Debit. You must be
              authorized to use your chosen payment method.
            </p>
          </section>
          <section className="mb-8" data-id="element-535">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-536">
              Cancellation & Refund
            </h3>
            <p className="text-gray-700" data-id="element-537">
              You can cancel within 14 days of purchase for a full refund.
              Partial refunds may be considered up to 28 days at our discretion,
              depending on whether any services have been provided. After 28
              days, refunds will no longer be available.
            </p>
          </section>
          <section className="mb-8" data-id="element-538">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-539">Liability</h3>
            <p className="text-gray-700" data-id="element-540">
              We are not responsible for losses or damages caused by misuse of
              appliances or systems, or from circumstances beyond our reasonable
              control.
            </p>
          </section>
          <section className="mb-8" data-id="element-541">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-542">
              Contact Us & Dispute Resolution
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-543">For any issues, contact:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4" data-id="element-544">
              <li data-id="element-545">Email: 23tata0716@gmail.com</li>
              <li data-id="element-546">Phone: 0800 055 4969</li>
            </ul>
            <p className="text-gray-700" data-id="element-547">
              We will reply during business hours.
            </p>
          </section>
          <section className="mb-8" data-id="element-548">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-549">
              Prohibited Use & Plan Exclusions
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-550">
              To maintain fair use and service quality, the following are
              excluded from all plans:
            </p>
            <ul className="list-disc pl-6 text-gray-700" data-id="element-551">
              <li data-id="element-552">Faults or damage existing before plan activation.</li>
              <li data-id="element-553">Damage caused by misuse, neglect, or tampering.</li>
              <li data-id="element-554">
                Repairs unrelated to normal appliance function (e.g., cosmetic
                damage).
              </li>
              <li data-id="element-555">Illegal or fraudulent use of our services or website.</li>
              <li data-id="element-556">Appliances not used according to manufacturer guidelines.</li>
            </ul>
            <p className="text-gray-700 mt-4" data-id="element-557">
              If any of these apply, your plan may be cancelled without refund
              or support.
            </p>
          </section>
          <section className="mb-8" data-id="element-558">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-559">
              Dispute Resolution (Emphasis)
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-560">
              If you have an issue with your service or purchase, please contact
              us first before raising a chargeback with your bank:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4" data-id="element-561">
              <li data-id="element-562">Email: 23tata0716@gmail.com</li>
              <li data-id="element-563">Phone: 0800 055 4969</li>
            </ul>
            <p className="text-gray-700" data-id="element-564">
              We strive to resolve disputes quickly and fairly. Please avoid
              raising chargebacks before speaking with us—we want to help.
            </p>
          </section>
          <section className="mb-8" data-id="element-565">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-566">Refunds</h3>
            <p className="text-gray-700" data-id="element-567">
              Refunds will be returned to your original payment method. Allow
              5–10 working days for processing depending on your provider.
            </p>
          </section>
          <section data-id="element-568">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-569">
              Terms Acceptance
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-570">
              By using our site or purchasing services, you agree to these Terms
              of Service ("Terms"). They apply to all users including browsers,
              customers, vendors, and content contributors. If you don't agree
              to these Terms, please do not use the website or services.
            </p>
            <p className="text-gray-700" data-id="element-571">
              Any new tools or features added will also be subject to these
              Terms.
            </p>
          </section>
          <div className="mt-8 p-6 bg-gray-50 rounded-lg" data-id="element-572">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-573">
              Questions About Our Terms?
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-574">
              If you have any questions about our terms and conditions, please
              contact our team.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-575">
              <a href="tel:08000554969" className="bg-[#3b82f6] text-white py-2 px-6 rounded-md font-medium hover:bg-[#1a3a6c] transition-colors text-center" data-id="element-576">
                Call 0800 055 4969
              </a>
              <a href="mailto:23tata0716@gmail.com" className="bg-white text-[#1a3a6c] py-2 px-6 rounded-md font-medium border border-[#1a3a6c] hover:bg-gray-50 transition-colors text-center" data-id="element-577">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default TermsConditions;